import React from 'react';
import { MachineImpactBreakdown } from '../../lib/types';
import { formatCurrency } from '../../lib/export';

interface MachineImpactTableProps {
  data: MachineImpactBreakdown[];
  className?: string;
}

export function MachineImpactTable({ data, className = '' }: MachineImpactTableProps) {
  return (
    <div className={`bg-white p-6 rounded-lg shadow ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">Machine Impact Breakdown</h3>
      <p className="text-sm text-gray-600 mb-4">Average impact per machine for campaigns by location</p>
      
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 font-medium text-gray-900">Machine</th>
              <th className="text-left py-3 px-4 font-medium text-gray-900">Location</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">Campaigns</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">Impressions</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">Total Impact</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">Avg Impact</th>
            </tr>
          </thead>
          <tbody>
            {data.map((machine) => (
              <tr key={machine.machineId} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-4 text-sm font-medium text-gray-900">{machine.machineName}</td>
                <td className="py-3 px-4 text-sm text-gray-600">{machine.location}</td>
                <td className="py-3 px-4 text-sm text-right text-gray-900">{machine.campaignCount}</td>
                <td className="py-3 px-4 text-sm text-right text-gray-900">{machine.impressions.toLocaleString()}</td>
                <td className="py-3 px-4 text-sm text-right font-medium text-green-600">
                  {formatCurrency(machine.totalImpact)}
                </td>
                <td className="py-3 px-4 text-sm text-right font-medium text-blue-600">
                  {formatCurrency(machine.averageImpact)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

